import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Apple, Monitor, Smartphone, Globe } from "lucide-react";
import SectionHeading from "../SectionHeading";
import { MT5_WINDOWS_URL, MT5_IOS_URL, MT5_ANDROID_URL } from "../../lib/api";
import { staggerVariants, VIEWPORT_ONCE } from "../../lib/motion";

const downloads = [
    {
        icon: Monitor,
        title: "Windows",
        caption: "MT5 desktop terminal for Windows 10/11",
        href: MT5_WINDOWS_URL,
        label: "Download",
    },
    {
        icon: Apple,
        title: "iOS",
        caption: "MT5 mobile for iPhone & iPad",
        href: MT5_IOS_URL,
        label: "Download",
    },
    {
        icon: Smartphone,
        title: "Android",
        caption: "MT5 mobile for Android devices",
        href: MT5_ANDROID_URL,
        label: "Download",
    },
    {
        icon: Globe,
        title: "Web Trader",
        caption: "No install — trade in browser",
        href: null,
        label: "Coming Soon",
    },
];

const cardVariants = staggerVariants({ y: 20, duration: 0.5, step: 0.06 });

export default function PlatformDownloads() {
    return (
        <section
            id="downloads"
            className="py-24 lg:py-28 bg-[#0A0E23]/40 border-y border-white/5"
        >
            <div className="xpo-container">
                <SectionHeading
                    overline="Get MT5"
                    title="Download anywhere. Trade everywhere."
                    align="center"
                />
                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-14">
                    {downloads.map((d, i) => (
                        <motion.a
                            key={d.title}
                            href={d.href || undefined}
                            target={d.href ? "_blank" : undefined}
                            rel={d.href ? "noreferrer" : undefined}
                            data-testid={`download-card-${d.title.toLowerCase().replace(/[ /]/g, "-")}`}
                            variants={cardVariants}
                            initial="hidden"
                            whileInView="visible"
                            custom={i}
                            viewport={VIEWPORT_ONCE}
                            className={`xpo-glass p-8 group ${d.href ? "cursor-pointer" : "cursor-default opacity-80"}`}
                        >
                            <d.icon size={28} className="text-[#A6E3DC] mb-5" />
                            <h3 className="text-lg font-bold text-white">
                                {d.title}
                            </h3>
                            <p className="text-slate-400 text-sm mt-1.5">
                                {d.caption}
                            </p>
                            <div className="flex items-center gap-1.5 text-[#A6E3DC] text-sm font-semibold mt-5 group-hover:translate-x-1 transition">
                                {d.label} <ArrowUpRight size={14} />
                            </div>
                        </motion.a>
                    ))}
                </div>
            </div>
        </section>
    );
}
